import React from 'react';

import SLICK_PDF from 'assets/slickpay-splash/time-off/doc/employee-evaluation-form.pdf';
import ICON_DOWNLOAD from 'assets/slickpay-splash/time-off/download.svg';
import ICON_IDEAS from 'assets/slickpay-splash/time-off/ideas.svg';
import ICON_STAFF from 'assets/slickpay-splash/time-off/staff.svg';
import ICON_WIN from 'assets/slickpay-splash/time-off/winning.svg';
import ExternalLink from 'components/generic/ExternalLink.component';
import { useTranslation } from 'providers/GILT.provider';
import C from 'utils/values/constant.util';

import CN from './TimeOffSplashBoxes.module.scss';

const LINK_APPRAISAL = 'http://getslick.com/blog/staff-appraisal';
const LINK_IDEAS = ' http://getslick.com/blog/top-5-ideas-staff-incentives';
const LINK_WIN = 'http://getslick.com/blog/3-winning-commission-structures';

const determineAdviceBoxes = (t) =>
  C([
    {
      image: ICON_STAFF,
      title: t('humanResources.splashOverview.tipsBoxes.box1Title'),
      link: LINK_APPRAISAL,
    },
    {
      image: ICON_DOWNLOAD,
      title: t('humanResources.splashOverview.tipsBoxes.box2Title'),
      link: SLICK_PDF,
      download: t('humanResources.splashOverview.tipsBoxes.box2Title'),
    },
    {
      image: ICON_IDEAS,
      title: t('humanResources.splashOverview.tipsBoxes.box3Title'),
      link: LINK_IDEAS,
    },
    {
      image: ICON_WIN,
      title: t('humanResources.splashOverview.tipsBoxes.box4Title'),
      link: LINK_WIN,
    },
  ]);

const TimeOffSplashBoxes = () => {
  const { t } = useTranslation();

  const adviceBoxes = determineAdviceBoxes(t);

  return (
    <div data-bem="TimeOffSplashBoxes">
      <div className={CN.sectionTitle} data-bem="TimeOffSplashBoxes_title">
        <div>{t('humanResources.splashOverview.tipsBoxes.title')}</div>
      </div>

      <section className={CN.flex} data-bem="TimeOffSplashBoxes__body">
        <div className={CN.container} data-bem="TimeOffSplashBoxes__container">
          {adviceBoxes.map(({ image, title, link }) => (
            <div key={title} className={CN.box} data-bem="TimeOffSplashBoxes__box">
              <div className={CN.link}>
                <ExternalLink link={link} download>
                  <img src={image} alt={title} />
                  <span className={CN.linkText}>{title}</span>
                  <div>{t('humanResources.splashOverview.tipsBoxes.learnMoreButton')}</div>
                </ExternalLink>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default TimeOffSplashBoxes;
